var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import merge from 'deepmerge';
import configureTooltip from '../tooltip/main';
import chartUtils from '../../../utils/chart-utils';

var getFlowSeriesType = function getFlowSeriesType(FlowType) {
    switch (FlowType) {
        case 'Sankey':
            return 'sankey';
        case 'Dependency':
            return 'dependencywheel';
        default:
            return 'sankey';
    }
};

var buildSankeyConfiguration = function buildSankeyConfiguration(flowConfig, seriesConfig, seriesDataObj, customConfig) {
    var valueFieldName = flowConfig.ValueFieldName;
    var fieldsLength = flowConfig.Fields.length;
    var seriesType = getFlowSeriesType(flowConfig.FlowType);
    var sourceNodeName = null;
    var targetNodeName = null;
    var targetNodeHeaderName = null;
    var sourceNodeHeaderName = null;
    var flowField = flowConfig.Fields[0];
    var nodes = [];
    var links = [];
    var counter = 0;
    var crumbFieldName = null;
    var targetCrumbFieldName = null;
    var crumbMetaName = null;
    var targetCrumbMetaName = null;
    var tooltipConfig = flowConfig.CompoundTipField;
    var valueFormat = flowConfig.valueFormat;
    var currencySymbol = flowConfig.currencySymbol;
    var NA_VALUE = '#N/A';
    var FIELD_VALUE = 'field';
    var SOURCE = 'source';
    var TARGET = 'target';
    var NODE_VALUE = 'node';
    var WEIGHT = 'weight';
    var CRUMB_FIELD_NAME = 'crumbFieldName';
    var CRUMB_DISPLAY_FIELD_NAME = 'crumbDisplayFieldName';
    var CRUMB_META_NAME = 'crumbMetaName';
    var CRUMB_VALUE = 'crumbValue';
    var FROM_VALUE = 'from';
    var TO_VALUE = 'to';
    var VALUE = 'Value';
    var CLASS_NAME = 'className';
    var ID = 'id';

    if (tooltipConfig !== null && tooltipConfig.toString().trim().length > 0) tooltipConfig = JSON.parse(chartUtils.replaceAll(JSON.stringify(tooltipConfig), '\x01', ''));

    if (flowField) {
        sourceNodeName = flowField.FieldName;
        sourceNodeHeaderName = flowField.HeaderName;
        crumbFieldName = flowField.CrumbFieldName;
        crumbMetaName = flowField.CrumbMetaName;
    }

    for (var flowIndex = 0; flowIndex < fieldsLength - 1; flowIndex++) {
        targetNodeName = flowConfig.Fields[flowIndex + 1].FieldName;
        targetNodeHeaderName = flowConfig.Fields[flowIndex + 1].HeaderName;
        targetCrumbFieldName = flowConfig.Fields[flowIndex + 1].CrumbFieldName;
        targetCrumbMetaName = flowConfig.Fields[flowIndex + 1].CrumbMetaName;

        var seriesDataLength = seriesDataObj[0].length;

        for (var dataIndex = 0; dataIndex < seriesDataLength; dataIndex++) {
            var item = seriesDataObj[0][dataIndex];

            if (item[sourceNodeName] == null || item[sourceNodeName] === NA_VALUE) item[sourceNodeName] = makeUnknownName(sourceNodeHeaderName);
            if (item[targetNodeName] == null || item[targetNodeName] === NA_VALUE) item[targetNodeName] = makeUnknownName(targetNodeHeaderName);

            var sourceNode = chartUtils.findValue(nodes, FIELD_VALUE, item[sourceNodeName]);
            var targetNode = chartUtils.findValue(nodes, FIELD_VALUE, item[targetNodeName]);

            var value = 0;
            if (item[valueFieldName] !== null || !isNaN(Number(item[valueFieldName]))) value = Number(item[valueFieldName]);

            var link = null;

            if (sourceNode !== null && targetNode !== null) {
                sourceNode.value += value;
                targetNode.value += value;

                link = chartUtils.findLink(links, SOURCE, sourceNode[NODE_VALUE], TARGET, targetNode[NODE_VALUE]);

                if (link === null) link = chartUtils.findLink(links, SOURCE, targetNode[NODE_VALUE], TARGET, sourceNode[NODE_VALUE]);

                if (link !== null) {
                    if (item[valueFieldName] != null) link[WEIGHT] += value;

                    continue;
                }
            }

            if (sourceNode === null) {
                sourceNode = {};
                sourceNode[NODE_VALUE] = counter;
                sourceNode[FIELD_VALUE] = item[sourceNodeName];
                sourceNode[WEIGHT] = value;
                sourceNode[CLASS_NAME] = item[sourceNodeName];
                sourceNode[ID] = item[sourceNodeName];

                if (tooltipConfig !== null && tooltipConfig.TooltipConfigs !== null && tooltipConfig.TooltipConfigs.length > 0) {
                    var tooltipConfigLength = tooltipConfig.TooltipConfigs.length;

                    for (var index = 0; index < tooltipConfigLength; index++) {
                        sourceNode[tooltipConfig.TooltipConfigs[index].Id] = item[tooltipConfig.TooltipConfigs[index].Id];
                    }
                }

                if (crumbFieldName && item[crumbFieldName]) {
                    sourceNode[VALUE] = item[crumbFieldName];
                    sourceNode[CRUMB_FIELD_NAME] = crumbFieldName;
                    sourceNode[CRUMB_DISPLAY_FIELD_NAME] = crumbFieldName;
                    sourceNode[CRUMB_META_NAME] = crumbMetaName;
                }

                nodes.push(sourceNode);
                counter++;
            }

            if (targetNode === null) {
                targetNode = {};
                targetNode[NODE_VALUE] = counter;
                targetNode[FIELD_VALUE] = item[targetNodeName];
                targetNode[WEIGHT] = value;
                targetNode[CLASS_NAME] = item[targetNodeName];
                targetNode[ID] = item[targetNodeName];

                if (tooltipConfig !== null && tooltipConfig.TooltipConfigs !== null && tooltipConfig.TooltipConfigs.length > 0) {
                    var _tooltipConfigLength = tooltipConfig.TooltipConfigs.length;

                    for (var _index = 0; _index < _tooltipConfigLength; _index++) {
                        targetNode[tooltipConfig.TooltipConfigs[_index].Id] = item[tooltipConfig.TooltipConfigs[_index].Id];
                    }
                }

                if (crumbFieldName !== null && item[crumbFieldName] !== null) {
                    targetNode[VALUE] = item[targetCrumbFieldName];
                    targetNode[CRUMB_FIELD_NAME] = targetCrumbFieldName;
                    targetNode[CRUMB_DISPLAY_FIELD_NAME] = targetCrumbFieldName;
                    targetNode[CRUMB_META_NAME] = targetCrumbMetaName;
                }

                nodes.push(targetNode);
                counter++;
            }

            link = {};
            link[SOURCE] = sourceNode[NODE_VALUE];
            link[TARGET] = targetNode[NODE_VALUE];
            link[WEIGHT] = 0;
            link[FROM_VALUE] = sourceNode[VALUE];
            link[TO_VALUE] = targetNode[VALUE];

            if (tooltipConfig !== null && tooltipConfig.TooltipConfigs !== null && tooltipConfig.TooltipConfigs.length > 0) {
                var _tooltipConfigLength2 = tooltipConfig.TooltipConfigs.length;

                for (var _index2 = 0; _index2 < _tooltipConfigLength2; _index2++) {
                    link[tooltipConfig.TooltipConfigs[_index2].Id] = item[tooltipConfig.TooltipConfigs[_index2].Id];
                }
            }

            if (!!crumbFieldName && !!item[crumbFieldName]) {
                link[crumbFieldName] = item[crumbFieldName];
                link[CRUMB_VALUE] = item[crumbFieldName];
                link[CRUMB_FIELD_NAME] = crumbFieldName;
            }

            if (item[valueFieldName] !== null) link[WEIGHT] = value;

            if (valueFieldName === null || valueFieldName.trim().length === 0) link[WEIGHT]++;

            links.push(link);
        }

        sourceNodeName = targetNodeName;
        sourceNodeHeaderName = targetNodeHeaderName;
        crumbFieldName = targetCrumbFieldName;
        crumbMetaName = targetCrumbMetaName;
    }

    return merge({
        data: links,
        nodes: nodes,
        type: seriesType,
        tooltip: configureTooltip(seriesType, _extends({}, seriesConfig, { valueFormat: valueFormat, currencySymbol: currencySymbol }))
    }, customConfig);
};

var makeUnknownName = function makeUnknownName(headerName) {
    return 'Unknown ' + headerName;
};

export default buildSankeyConfiguration;